import React, { PureComponent } from "react";
import EyeIcon from "mdi-react/EyeIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import AppConfig from "../../../../config/appconfig.json";
import { Alert } from "reactstrap";
import { checkAgreement } from "./CheckAgreement";
import { Link } from "react-router-dom";

export default class LogInForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      username: this.getUsernameLogin(),
      password: "",
      rememberme: false,
      isLoginError: false,
      loginErrorMsg: ""
    };

    this.showPassword = this.showPassword.bind(this);
    this.handleSubmitLogin = this.handleSubmitLogin.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword
    });
  }

  getUsernameLogin() {
    // console.log("get username from localStorage");
    let value = localStorage.getItem("usernameLogin");
    if (value == null) value = "";
    return value;
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmitLogin(event) {
    // console.log("form submission to url" + AppConfig.BACK_END_URL);
    this.setState({ isLoginError: false });
    const request = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: this.state.username,
        password: this.state.password
      })
    };
    // console.log(request);
    // Call Back-End Services
    fetch(`${AppConfig.BACK_END_URL}/APIClient/Authenticate`, request)
      .then(response => {
        // console.log(response);
        if (response.ok === false) {
          this.setState({ isLoginError: true });
        }
        return response.json();
      })
      .then(json => {
        // console.log(json);
        if (this.state.isLoginError) {
          const respObj = JSON.parse(json);
          this.setState({ loginErrorMsg: "Login failed: " + respObj.Message });
        } else {
          const respObj = JSON.parse(json);
          localStorage.setItem("usernameLogin", respObj.Name);
          localStorage.setItem("kbeSid", respObj.Sid);
          localStorage.setItem("kbeEmail", respObj.email);
          // this.checkAgreement(respObj.Sid);
          checkAgreement(respObj.Sid);
        }
      })
      .catch(() => {
        this.setState({
          isLoginError: true,
          loginErrorMsg: "Something went wrong"
        });
      });
    event.preventDefault();
  }

  render() {
    return (
      <div>
        {this.state.isLoginError ? (
          <Alert color="danger">
            <div className="alert__content">
              <p>
                <span className="bold-text">Error!</span>{" "}
                {this.state.loginErrorMsg}
              </p>
            </div>
          </Alert>
        ) : (
          <div />
        )}
        <form className="form" onSubmit={this.handleSubmitLogin}>
          <div className="form__form-group">
            <label className="form__form-group-label">Username</label>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <AccountOutlineIcon />
              </div>
              <input
                type="text"
                name="username"
                placeholder="Username or Email"
                value={this.state.username}
                onChange={this.handleInputChange}
                required
              />
            </div>
          </div>
          <div className="form__form-group">
            <label className="form__form-group-label">Password</label>
            <div className="form__form-group-field">
              <div className="form__form-group-icon">
                <KeyVariantIcon />
              </div>
              <input
                type={this.state.showPassword ? "text" : "password"}
                name="password"
                required
                placeholder="Password"
                value={this.state.password}
                onChange={this.handleInputChange}
              />
              <button
                className={`form__form-group-button${
                  this.state.showPassword ? " active" : ""
                }`}
                onClick={e => this.showPassword(e)}
              >
                <EyeIcon />
              </button>
            </div>
            <div className="account__forgot-password">
              <Link to="/forgot_pass">Forgot a password?</Link>
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <label className="checkbox-btn">
                <input
                  type="checkbox"
                  className="checkbox-btn__checkbox"
                  name="rememberme"
                  checked={this.state.rememberme}
                  onChange={this.handleInputChange}
                />
                <span className="checkbox-btn__checkbox-custom">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className="mdi-icon"
                  >
                    <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                  </svg>
                </span>
                <span className="checkbox-btn__label">Remember me</span>
              </label>
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary account__btn account__btn--small"
          >
            Sign In
          </button>
          <Link
            className="btn btn-primary account__btn account__btn--small"
            to="/register"
          >
            <center>Create Account</center>
          </Link>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/log_in/components/LogInForm.js